import { useLoader } from '../store';

/** Missing or non-Earth orbits are data availability, not renderer crashes. */
export function OrbitDataStatus() {
  const dataset = useLoader((s) => s.dataset);
  if (!dataset) return null;
  const pending = dataset.missions.filter(
    (m) => m.orbit.tleStatus === 'unverified' || (!m.orbit.tle && m.orbit.type !== 'lunar'),
  );
  if (!pending.length) return null;
  return (
    <details
      className="rounded-control border border-hairline px-2 py-1 text-[10px] text-ink-3"
      data-testid="orbit-data-status"
    >
      <summary className="cursor-pointer">
        Orbital data · {pending.length} reference / unavailable records
      </summary>
      <p className="my-1">
        Deep-space missions need ephemerides. Outlined GEO slots are planning references and do not produce
        calculated contacts. Unverified identities are excluded from propagation.
      </p>
      {pending.map((m) => (
        <div className="py-0.5" key={m.id}>
          <span className="text-ink-2">{m.shortName || m.name}</span> ·{' '}
          {m.orbit.tleIssue ??
            (['deep_space', 'l1'].includes(m.orbit.type.toLowerCase())
              ? 'deep-space ephemeris required'
              : m.orbit.position
                ? 'reference GEO slot'
                : 'no orbital elements')}
        </div>
      ))}
    </details>
  );
}
